import { GetCreateReportIncorrectProductInfo, getReportIncorrectProductInfo } from "@NA/Services/ADIProductDetailsReportIncorrect";
import { markSkipOnCompleteIfOnSuccessIsSet } from "@insite/client-framework/HandlerCreator";
import { createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";

type HandlerType = CustomApiHandler<GetCreateReportIncorrectProductInfo>;


export const SendDataReportIncorrectProductInfoApi: HandlerType = async props => {
    await getReportIncorrectProductInfo(props.parameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [SendDataReportIncorrectProductInfoApi, ExecuteOnSuccessCallback];

const productDetailsReportIncorrect = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        feedbackEmail: "",
        feedbackMessage: "",
        feedbackfor: "",
        productUrl: "",
        sku: "",
        onSuccess: () => { }
    },
    "ProductDetailsReportIncorrect",
);
export default productDetailsReportIncorrect;
